import { ReactElement } from 'react';
import { Form, Input, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { CustomerSearchCondition } from '../types';
import { PHONE_PATTERN } from '../../../../shared/phonePattern';

interface Props {
  initialValues: CustomerSearchCondition;
  onSearch: (values: CustomerSearchCondition) => void;
  onClear: () => void;
}

const phoneRule = {
  validator: (_: unknown, value: string | undefined) => {
    if (!value || value === '') {
      return Promise.resolve();
    }
    if (PHONE_PATTERN.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('10〜11桁の数字で入力してください'));
  },
};

const SearchForm = ({ initialValues, onSearch, onClear }: Props): ReactElement => {
  const [form] = Form.useForm<CustomerSearchCondition>();

  const handleClear = () => {
    form.setFieldsValue({ name: undefined, phone: undefined, mobilePhone: undefined });
    onClear();
  };

  return (
    <Form form={form} layout='inline' initialValues={initialValues} onFinish={onSearch}>
      <Form.Item name='name' label='氏名'>
        <Input placeholder='氏名を入力' allowClear />
      </Form.Item>

      <Form.Item name='phone' label='電話番号' rules={[phoneRule]}>
        <Input placeholder='0312345678' allowClear />
      </Form.Item>

      <Form.Item name='mobilePhone' label='携帯電話' rules={[phoneRule]}>
        <Input placeholder='09012345678' allowClear />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type='primary' htmlType='submit' icon={<SearchOutlined />}>
            検索
          </Button>
          <Button onClick={handleClear} icon={<ClearOutlined />}>
            クリア
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SearchForm;
